module.exports = __webpack_public_path__ + "img/ir.9a5379e.svg";